import React from 'react'

import { AWSOnboardingForm } from 'components/getting-started/aws/AWSOnboardingForm'
import { EditAuthenticationForm } from 'components/status-checks/edit/EditAuthenticationForm'
import {
  ObservabilityToolType,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'

export function ThirdPartyAuth({
  externalIntegrations,
  onClose,
  selectedIntegration,
  type
}: {
  externalIntegrations: TeamExternalIntegration[]
  selectedIntegration?: TeamExternalIntegration | undefined
  type: ObservabilityToolType
  onClose: () => void
}) {
  switch (type) {
    case ObservabilityToolType.AWS:
      return selectedIntegration ? (
        <EditAuthenticationForm
          externalIntegration={selectedIntegration}
          externalIntegrations={externalIntegrations}
          handleCancel={onClose}
        />
      ) : (
        <AWSOnboardingForm
          externalIntegrations={externalIntegrations}
          hasIntroText={false}
          onSuccess={onClose}
        />
      )

    case ObservabilityToolType.AZURE:
      return <>type: {type}</>

    case ObservabilityToolType.GCP:
      return <>type: {type}</>

    default:
      return null
  }
}
